import React from "react"
import SEO from "../../shared/seo"
import Layout from "../../shared/components/organisms/layout/layout"
import "../../shared/styles/index.scss"
import SaveModal from "../../shared/components/modals/save-modal/save-modal"
// import PrincipalModal from "../../components/molecules/principal-modal/principal-modal"
import ContentMG from "../../components/organisms/content-mg/content-mg"
import { graphql } from "gatsby"
import ModalComponentHome from "../../components/molecules/modal-home/modal-home"

class NuestroMundo extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      mobile: false,
      isLog: false,
      activeModalSave: false,
      modalActive: null,
      campanas: this.props.data.allContentfulNolCampanas.edges,

    }
  }

  // showModalPrincipal = () => {
  //   setTimeout(() => {
  //     localStorage.setItem("modalalreadyshowed", true)
  //     this.setState({
  //       modalActive: (
  //         <PrincipalModal
  //           closeModal={() => this.setState({ modalActive: null })}
  //         />
  //       ),
  //     })
  //   }, 5000)
  // }

  setModalState = () => {
    if (this.state.activeModalSave === false) {
      this.setState({
        modalActive: (
          <SaveModal closeModal={() => this.setState({ modalActive: null })} />
        ),
      })
    } else {
      this.setState({ modalActive: null })
    }
  }

  componentDidMount() {
    sessionStorage.setItem(
      "LAST_SECTION",
      JSON.stringify({ title: "Nuestro Mundo", slug: "magazin/nuestro-mundo/" })
    )

    // if (!localStorage.getItem("modalalreadyshowed")) {
    //   this.showModalPrincipal()
    // }
    if (window.innerWidth < 1024) {
      this.setState({
        mobile: true,
      })
    }
    window.addEventListener("resize", this.updateDimensions)

    if (typeof window !== `undefined`) {
      if (sessionStorage.getItem("slugFilterMagazin") === null) {
        sessionStorage.setItem("slugFilterMagazin", "lo-ultimo")
        sessionStorage.setItem("titleFilterMagazin", "Lo Último")
      }
    }
  }

  getArticleaByAge = () => {
    return this.props.data.allContentfulNolArticulos.nodes
      .map(art =>
        art.segmentoDelArticulo.filter(
          a =>
            a.nombreEtiqueta === this.getAgeSegment(this.calculateAge()) ||
            a.nombreEtiqueta === "Anónimo"
        ).length > 0
          ? art
          : null
      )
      .filter(e => e !== null)
  }

  getRestrictedArticles = () => {
    let tempItems = []
    this.getArticleaByAge().map(item => {
      // console.log((item.paisesDeRestriccionDelArticulo === null || !item.paisesDeRestriccionDelArticulo.includes(process.env.LOCALE.split('-')[1])))
      if (
        (item.paisesDeRestriccionDelArticulo === null ||
          !item.paisesDeRestriccionDelArticulo.includes(
            process.env.LOCALE.split("-")[1]
          )) &&
        item.seccion !== "historia-uteros"
      ) {
        tempItems.push(item)
      }
    })
    return tempItems
  }

  calculateAge = () => {
    if (typeof window !== "undefined") {
      if (localStorage.getItem("USER_INFO") === null) {
        return 0
      } else {
        var today = new Date()
        var birthDate = new Date(
          JSON.parse(localStorage.getItem("USER_INFO")).birthdate
        )
        var age = today.getFullYear() - birthDate.getFullYear()
        var m = today.getMonth() - birthDate.getMonth()
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
          age--
        }
        return age
      }
    } else {
      return 0
    }
  }

  getAgeSegment = age => {
    if (age >= 9 && age <= 17) {
      return "Adolescente"
    } else if (age >= 18 && age <= 24) {
      return "Adulto Joven"
    } else if (age >= 25) {
      return "Adulto"
    } else {
      return "Anónimo"
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions)
  }

  updateDimensions = () => {
    if (window.innerWidth < 1024) {
      this.setState({
        mobile: true,
      })
    } else {
      this.setState({
        mobile: false,
      })
    }
  }

  render() {
    return (
      <Layout title={this.props.data.allContentfulNolHomeTercerNivel.nodes[0].metaTitulo.slice(0,34)} mobile={this.state.mobile} modalActive={this.state.modalActive}>
        <SEO
          title={this.props.data.allContentfulNolHomeTercerNivel.nodes[0].metaTitulo.slice(
            0,
            34
          )}
          description={this.props.data.allContentfulNolHomeTercerNivel.nodes[0].metaDescripcion.metaDescripcion.split("\n")[0].slice(
            0,
            154
          )}
          url={"/magazin/nuestro-mundo/"}
          image={
            this.props.data.allContentfulNolHomeTercerNivel?.nodes?.[0]?.metaImagen?.file?.url
              ? `https:${this.props.data.allContentfulNolHomeTercerNivel?.nodes?.[0]?.metaImagen?.file?.url}`
              : null
          }
        />

        <ModalComponentHome
          campana={this.state.campanas}
          mobile={this.state.mobile}
          section={"nuestro-mundo"}
        />

        <ContentMG
          contennInfo={this.getRestrictedArticles()}
          mobile={this.state.mobile}
          infoCategory={
            this.props.data.allContentfulNolHomeTercerNivel.nodes[0]
          }
          isLog={this.state.isLog}
          setModalState={this.setModalState}
          // defaultBanner={this.state.defaultBanner}
        />
      </Layout>
    )
  }
}
export const query = graphql`
  query GET_MAGAZIN_CONTENT($locale: String!) {
    allContentfulNolArticulos(
      filter: {
        node_locale: { eq: $locale }
        seccionDelArticulo: { eq: "Nuestro Mundo" }
      }
      sort: { fields: fechaDePublicacion, order: DESC }
    ) {
      nodes {
        fechaDePublicacion
        id
        paisesDeRestriccionDelArticulo
        contentful_id
        segmentoDelArticulo {
          nombreEtiqueta
        }
        nombreCreadorArticulo        
        seccion
        tipoDeArticulo
        imagenCreadorArticulo {
          file {
            url
          }
          description
        }
        creadorArtculo
        tituloArticulo
        descripcionArticulo
        slug
        metaDescripcion {
          metaDescripcion
        }
        metaImagen {
          file {
            url
          }
          description
        }
        metaTitulo
        imagenArticuloPrevisualizacion {
          file {
            url
            details {
              image {
                height
              }
            }
          }
          description
          fixed {
            base64
          }
        }
        categorias {
          titulo
          slug
        }
        etiquetas {
          slug
        }
      }
    }
    allContentfulNolHomeTercerNivel(
      filter: { node_locale: { eq: $locale }, slug: { in: ["nuestro-mundo", "nuestro-mundo/"] }}
    ) {
      nodes {
        titulo
        slug
        autopauta1 {
          tituloMagazin
          descripcion
          botonRedireccion
          boton
          imagenDestacada {
            description
            file {
              url
            }
          }
        }
        autopautasDelGrid {
          botonRedireccion
          imagenDestacadaDelGrid {
            file {
              url
            }
            description
          }
        }
        categorias {
          titulo
          slug
          bannerDeInterna {
            description
            file {
              url
              details {
                image {
                  height
                }
              }
            }
            fixed {
              base64
            }
          }
          bannerArticulo {
            bannerArticulo {
              description
              file {
                url
                details {
                  image {
                    height
                  }
                }
              }
              fixed {
                base64
              }
            }
            categorias {
              titulo
            }
            tituloArticulo
            slug
            ctaBanner
          }
        }
        filtroSuperior {
          nombreEtiqueta
          slug
        }
        metaTitulo
        metaImagen {
          file {
            url
          }
        }
        metaDescripcion {
          metaDescripcion
        }
      }
    }
      allContentfulNolCampanas(filter: {seccionVisualizacion: {in: "nuestro-mundo"}}) {
          edges {
              node {
                  id
                  fechaFin
                  esPermanente
                  idCampana
                  esCampanaHome
                  tipoVisualizacion
                  cantidadVisualizaciones
                  seccionVisualizacion
                  recursos {
                      id
                      imagenesDeBanner {
                          description
                          file {
                              url
                          }
                      }
                      redireccion
                      tipoDeBanner
                      codigoVideo
                  }
                  node_locale
                  paisesDeRestriccionCampana
              }
          }
      }
  }
`

export default NuestroMundo
